import { render, staticRenderFns } from "./cargoPostCodeSelect.vue?vue&type=template&id=345c1978&scoped=true&"
import script from "./cargoPostCodeSelect.vue?vue&type=script&lang=js&"
export * from "./cargoPostCodeSelect.vue?vue&type=script&lang=js&"
import style0 from "./cargoPostCodeSelect.vue?vue&type=style&index=0&id=345c1978&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345c1978",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('345c1978')) {
      api.createRecord('345c1978', component.options)
    } else {
      api.reload('345c1978', component.options)
    }
    module.hot.accept("./cargoPostCodeSelect.vue?vue&type=template&id=345c1978&scoped=true&", function () {
      api.rerender('345c1978', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/cargoPostCodeSelect.vue"
export default component.exports